module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('router-link', {
    staticClass: "nav-item",
    staticStyle: {
      "color": "darkslategrey"
    },
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Stickly")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])])])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nav-toggle"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-right nav-menu"
  }, [_c('a', {
    staticClass: "nav-item",
    attrs: {
      "href": "mailto:support@stickly.com"
    }
  }, [_vm._v("\n                    Contact\n                  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fedd73c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 167
// module chunks = 0